<!-- 文字配置 -->
<template>
  <div>
    <el-collapse accordion>
      <el-collapse-item title="文本设置">
        <el-form-item label="字体类型">
          <el-select
            filterable
            allow-create
            v-model="main.activeOption.fontFamily"
            size="small"
          >
            <el-option
              v-for="item in dicOption.fontFamily"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字体大小">
          <el-input-number
            v-model="main.activeOption.fontSize"
            :max="200"
            size="small"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="字体颜色">
          <el-color-picker v-model="main.activeOption.color"></el-color-picker>
        </el-form-item>
        <el-form-item label="字体间距">
          <el-input-number
            v-model="main.activeOption.split"
            size="small"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="字体行高">
          <el-input-number
            v-model="main.activeOption.lineHeight"
            size="small"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="字体背景">
          <el-color-picker
            v-model="main.activeOption.backgroundColor"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="文字粗细">
          <el-select v-model="main.activeOption.fontWeight" size="small">
            <el-option
              v-for="item in dicOption.fontWeight"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对齐方式">
          <el-select v-model="main.activeOption.textAlign" size="small">
            <el-option
              v-for="item in dicOption.textAlign"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="换行方式">
          <el-select v-model="main.activeOption.textWrap" size="small">
            <el-option
              v-for="item in dicOption.textWrap"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最大行数">
          <el-input-number
            v-model="main.activeOption.lineMax"
            :min="0"
            size="small"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="边框">
        <el-form-item label="显示边框">
          <el-switch
            v-model="main.activeOption.border"
            size="small"
          ></el-switch>
        </el-form-item>
        <template v-if="main.activeOption.border">
          <el-form-item label="边框粗细">
            <el-input v-model="main.activeOption.borderWidth" size="small"></el-input>
          </el-form-item>
        </template>
        <template v-if="main.activeOption.border">
          <el-form-item label="边框颜色">
            <el-color-picker
              v-model="main.activeOption.borderColor"
            ></el-color-picker>
          </el-form-item>
        </template>
      </el-collapse-item>
      <el-collapse-item title="跑马灯设置">
        <el-form-item label="开启">
          <el-switch
            v-model="main.activeOption.scroll"
            size="small"
          ></el-switch>
        </el-form-item>
        <template v-if="main.activeOption.scroll">
          <el-form-item label="滚动速度">
            <el-input v-model="main.activeOption.speed" size="small"></el-input>
          </el-form-item>
        </template>
      </el-collapse-item>
      <el-collapse-item title="提示语设置">
        <el-form-item label="开启">
          <el-switch
            v-model="main.activeOption.hasTips"
            size="small"
          ></el-switch>
        </el-form-item>
        <template v-if="main.activeOption.hasTips">
          <el-form-item label="提示语内容">
            <el-input
              v-model="main.activeOption.tipsContent"
              size="small"
            ></el-input>
          </el-form-item>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { dicOption } from "@/option/config";
export default {
  name: "textAreaModel",
  data() {
    return {
      dicOption: dicOption,
    };
  },
  inject: ["main"],
};
</script>

<style></style>
